import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../lib/utils.js';
export function Crest({ abbr = '', color, logoUrl, alt = '', className }) {
    if (logoUrl) {
        return (_jsx("img", { className: cn('h-8 w-8 flex-shrink-0 rounded-full border-2 border-surface bg-surface object-cover', className), src: logoUrl, alt: alt || abbr }));
    }
    const text = abbr.slice(0, 3).toUpperCase();
    return (_jsx("span", { "data-len": text.length, style: { background: color ?? 'var(--color-ink-3)' }, className: cn('inline-grid h-8 w-8 flex-shrink-0 place-items-center rounded-full border-2 border-surface font-ui text-[10.5px] font-bold uppercase leading-none tracking-[0.03em] text-white', text.length === 3 && 'text-[9px] tracking-[0.01em]', className), children: text }));
}
export function CrestPair({ home = {}, away = {}, className }) {
    return (_jsxs("span", { className: cn('inline-flex items-center [&>*+*]:-ml-2.5', className), children: [_jsx(Crest, { ...home }), _jsx(Crest, { ...away })] }));
}
//# sourceMappingURL=crest.js.map